import { SessionStore } from '~/stores/session'

export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return
  if (to.fullPath === from.fullPath) return // initial site load

  const session = SessionStore.use()
  session.prevPage = from.fullPath
})
